import React, { useEffect, useState } from 'react';
import { Checkbox, CheckboxProps, Input, message, Modal, Select, SelectProps } from 'antd';
import { fetcher } from '../../../extras/fetcher';
import { ForkliftInterface } from '../../../types/forklift.interface';
import { AddNotificationType } from './ForkliftNotification';
import { ForkliftAlertInterface } from '../../../types/forkliftAlert.interface';
import { UsersInterface } from '../../../types/users.interface';


interface Props {
  open : boolean;
  handleSetModalOpened: (opened: boolean) => void;
  handleSetData: (data: ForkliftAlertInterface) => void;
  notification: AddNotificationType;
}
export const ModalAddNotification = (props: Props) => {


  const [moveLoading, setMoveLoading] = useState<boolean>(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [inputValue, setInputValue] = useState<AddNotificationType>({
    ...props.notification
  });

  const [usersOptions, setUsersOptions] = useState<SelectProps['options']>([]);
  const [forkliftsOptions, setForkliftsOptions] = useState<SelectProps['options']>([]);


  useEffect(() => {
    getAllForklifts();
    getAllUsers();
  }, []);

  const getAllForklifts = async () => {
    const data = await fetcher(`forklift`);
    if(data.status === 403) {
      return;
    }

    const result: ForkliftInterface[] = data.result;
    const options: SelectProps['options'] = result.map((forklift) => {

      return {
        label: forklift.number,
        value: forklift.id,
      }

    });

    setForkliftsOptions(options);

  }

  const getAllUsers = async () => {
    const data = await fetcher(`user`);
    if(data.status === 403) {
      return;
    }

    const result: UsersInterface[] = data.result;
    const options: SelectProps['options'] = result.map((user) => {

      return {
        label: `${user.firstname} ${user.lastname}`,
        title: `${user.firstname} ${user.lastname}`,
        value: user.id,
      }

    });

    setUsersOptions(options);

  }



  const handleCancel = () => {
    props.handleSetModalOpened(false);
    setInputValue({
      id: '',
      active: true,
      forkliftIds: [],
      hours: 24,
      userIds: [],
      withoutWeekends: true,
    });
  }

  const handleOk = async () => {
    setMoveLoading(true);




    let payload: AddNotificationType = inputValue;

    if(payload.id === '') {
      delete payload.id;
    }


    const data = await fetcher(`forklift/alert`,payload.id ? 'PUT' : 'POST', inputValue);

    if(data.status === 403) {
      messageApi.open({
        type: 'error',
        content: 'Nie posiadasz wymaganych uprawnień!',
      });
      setMoveLoading(false);
      return;
    }

    if(data.result.error) {
      messageApi.open({
        type: 'error',
        content: data.result.error,
      });
    } else {
      messageApi.open({
        type: 'success',
        content: payload.id ? `Powiadomienia zostało zmodyfikowane.` : `Powiadomienie dodane.`,
      });

      setInputValue({
        id: '',
        active: true,
        forkliftIds: [],
        hours: 24,
        userIds: [],
        withoutWeekends: true,
      });

      const result: ForkliftAlertInterface = data.result;

      props.handleSetData(result);
    }


    props.handleSetModalOpened(false);
    setMoveLoading(false);


    }






  const handleInputChange = (key: keyof AddNotificationType, value: string | number | boolean) => {
    setInputValue((prev) => ({...(prev || {}), [key]: value}));
  };


  useEffect(() => {
    if (props.open) {
      setInputValue({
        id: props.notification.id ?? '',
        active: props.notification.active ?? true,
        forkliftIds: props.notification.forkliftIds ?? [],
        hours: props.notification.hours ?? 24,
        userIds: props.notification.userIds ?? [],
        withoutWeekends: props.notification.withoutWeekends ?? true,
      });
    }
  }, [props.open]);



  const handleWithoutWeekend: CheckboxProps['onChange'] = (e) => {
    handleInputChange('withoutWeekends', e.target.checked)
  }

  const handleActive: CheckboxProps['onChange'] = (e) => {
    handleInputChange('active', e.target.checked)
  }


  const handleChangeForklifts = (value: string[]) => {
    setInputValue((old) => {
      return {
        ...old,
        forkliftIds: value,
      }
    })
  };

  const handleChangeUsers = (value: string[]) => {
    setInputValue((old) => {
      return {
        ...old,
        userIds: value,
      }
    })
  };


  return (

<>
  <Modal
    bodyStyle={{padding: '20px'}}
    title={'Dodawanie Powiadomienia'}
    open={props.open}
    onOk={handleOk}
    onCancel={handleCancel}
    confirmLoading={moveLoading}
    style={{borderRadius: '8px'}}
  >
    <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>

      <Checkbox value={inputValue.active} onChange={handleActive} checked={inputValue.active}>Powiadomienie Aktywne</Checkbox>

      <label style={{marginBottom: '5px'}}>Ile godzin</label>
      <Input
        value={inputValue.hours}
        type={'number'}
        onChange={(e) => handleInputChange('hours', Number(e.target.value))}
        style={{width: '100%'}}
        placeholder={'Ile godzin'}
      />
      <Checkbox value={inputValue.withoutWeekends} onChange={handleWithoutWeekend} checked={inputValue.withoutWeekends}>Pomijaj Weekendy</Checkbox>

      <label style={{marginBottom: '5px'}}>Wózki Widłowe</label>
      <Select
        mode="multiple"
        allowClear
        style={{width: '100%'}}
        placeholder="Wybierz Wózki Widłowe"
        defaultValue={[]}
        value={inputValue.forkliftIds}
        onChange={handleChangeForklifts}
        options={forkliftsOptions}
      />


      <label style={{marginBottom: '5px'}}>Użytkownicy</label>
      <Select
        mode="multiple"
        allowClear
        style={{width: '100%'}}
        placeholder="Wybierz Użytkowników"
        defaultValue={[]}
        onChange={handleChangeUsers}
        value={inputValue.userIds}
        options={usersOptions}
      />

    </div>
  </Modal>
  {contextHolder}
</>
  );
}
